// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media print {
  @page {
    size: A4;
    margin: 10mm;
  }

  body * {
    visibility: hidden;
    font-family: "Times New Roman", Times, serif;
  }

  #divToPrint,
  #divToPrint * {
    visibility: visible;
  }

  #divToPrint {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    /* zoom: 150%; */
    transform: scale(0.95);
    transform-origin: top left;
    font-size: 20px;
  }

  /* HIDE UI */
  .hideBtn,
  #hideDate,
  #hideVerifiedText {
    display: none !important;
    visibility: hidden !important;
  }

  /* FIX BOOTSTRAP ROW OVERFLOW */
  .row {
    display: block !important;
  }

  /* TABLE SAFETY */
  table {
    page-break-inside: auto;
  }

  tr {
    page-break-inside: avoid;
  }

  /* IMPORTANT FIX */
  .causeListHeading {
    page-break-after: auto;
  }
}
`, "",{"version":3,"sources":["webpack://./src/app/dashboard/causeList/printCauseListDisposal.css"],"names":[],"mappings":"AAAA;EACE;IACE,QAAQ;IACR,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,4CAA4C;EAC9C;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,WAAW;IACX,gBAAgB;IAChB,sBAAsB;IACtB,0BAA0B;IAC1B,eAAe;EACjB;;EAEA,YAAY;EACZ;;;IAGE,wBAAwB;IACxB,6BAA6B;EAC/B;;EAEA,+BAA+B;EAC/B;IACE,yBAAyB;EAC3B;;EAEA,iBAAiB;EACjB;IACE,uBAAuB;EACzB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA,kBAAkB;EAClB;IACE,sBAAsB;EACxB;AACF","sourcesContent":["@media print {\n  @page {\n    size: A4;\n    margin: 10mm;\n  }\n\n  body * {\n    visibility: hidden;\n    font-family: \"Times New Roman\", Times, serif;\n  }\n\n  #divToPrint,\n  #divToPrint * {\n    visibility: visible;\n  }\n\n  #divToPrint {\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 100%;\n    /* zoom: 150%; */\n    transform: scale(0.95);\n    transform-origin: top left;\n    font-size: 20px;\n  }\n\n  /* HIDE UI */\n  .hideBtn,\n  #hideDate,\n  #hideVerifiedText {\n    display: none !important;\n    visibility: hidden !important;\n  }\n\n  /* FIX BOOTSTRAP ROW OVERFLOW */\n  .row {\n    display: block !important;\n  }\n\n  /* TABLE SAFETY */\n  table {\n    page-break-inside: auto;\n  }\n\n  tr {\n    page-break-inside: avoid;\n  }\n\n  /* IMPORTANT FIX */\n  .causeListHeading {\n    page-break-after: auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
